// removed by extract-text-webpack-plugin
module.exports = {"section":"_3n3Eab1r","nav":"_3ehEspV6","weekNav":"_2qjaiXDa","arrow":"_2hOEwsIZ","greyBar":"_3wdz9ft3","table":"_4Hwte2FB","type":"_295IBUuX","slopes":"_1FYWLTaZ","empty":"_1ZRetOwe","orangeBar":"_1mTUAMtn"};


//////////////////
// WEBPACK FOOTER
// ./src/client/webapp/components/WeekTable/WeekTable.styl
// module id = 404
// module chunks = 0